import type {
  BlockStateDefinition,
  ImplicitDependencyGroup,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importCategoryFilterComponent = () =>
  import(
    /* webpackChunkName: "category-filter-block" */
    './CategoryFilter'
  );

const CategoryFilter = lazy(importCategoryFilterComponent);

class CategoryFilterBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'CategoryFilter';
  }

  getBlockControlMethods() {
    return [
      {
        id: 'clearFilters' as const,
        label: 'Clear Filters',
        method: (blockState: BlockStateUnionType) => {
          return {
            ...blockState,
            filter: undefined,
          };
        },
      },
    ];
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  getComponent() {
    return CategoryFilter;
  }

  getImplicitDependencyGroups(): ImplicitDependencyGroup {
    return { usingDataSourcesResponse: true, isEntitySuspended: true };
  }

  preload() {
    return {
      blockPreload: importCategoryFilterComponent,
    };
  }
}

export default CategoryFilterBlockStateDefinition;
